import { css } from '@emotion/css';

export const unpublishedChangesStyles = css`
  &:hover,
  &:active {
    // replace it with purple-200 whenever added in the design system.
    background-color: #dadbfc;
  }
`;

export const publishedChangesStyles = css`
  &:hover,
  &:active {
    background-color: var(--gray-200);
  }
`;

export const labelBorderRadius = css`
  border-radius: 2.2rem;
`;
